import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Customer } from '../../core/models/customer';
import { RequestWrap } from '../../core/models/request-wrap';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ThemeConfig } from '../../core/helpers/theme-config';

const customersUrl = `/customers?limit=${ThemeConfig.itemsPerPage}`
const singleCustomerUrl = '/customers'
@Injectable()
export class CustomersService {

  constructor(
    private http: HttpClient
  ) {}

  getCustomers(pageNumber: number = 1, query?: string): Observable<RequestWrap<Customer[]>> {
    let params = new HttpParams().set('pagenr', pageNumber.toString());

    params = query
      ? params.set('search', query)
      : params

    return this.http.get<RequestWrap<Customer[]>>(
      environment.baseApiUrl + customersUrl,
      {
        params
      }
    )
  }

  getCustomerById(id: string): Observable<Customer> {
    return this.http.get<Customer>(
      `${environment.baseApiUrl}${singleCustomerUrl}/${id}`
    )
  }
}
